module.exports = __webpack_public_path__ + "7aee1458dcb6d8d35d633d0be6bf0a9a.MP3";